import { masterAdminConstants } from '../constants';
import { masterAdminService } from '../services';
import { loader, alert as customAlert } from 'helpers';
import i18n from 'i18n';

const defaultFailedText = 'api_messages.SOMETHING_WENT_WRONG';
export const masterAdminActions = {
   addNewAdmin,
   editAdmin,
   deleteAdmin,
   getTableDatas,
   getAdminByID,
   getListMerchants,
   editPassword,
   emailPasswordExpire
};

function addNewAdmin(params) {
   return dispatch => {
      loader(dispatch, true)
      masterAdminService.addNewAdmin(params)
         .then(
            response => {
               if (response.status) {
                  dispatch(success(response.data));
                  customAlert(dispatch, 'success', i18n.t('warning_messages.admin_was_created'));
               } else {
                  if(!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
               }
            },
            error => {
               customAlert(dispatch, 'error', i18n.t(defaultFailedText))
            }
         ).then(() => {
            loader(dispatch, false)
         })
   };
   function success(tmp) { return { type: masterAdminConstants.ADD_NEW_ADMIN_SUCCESS, tmp } }
}

function editAdmin(params) {
   return dispatch => {
      loader(dispatch, true)
      masterAdminService.editAdmin(params)
         .then(
            response => {
               if (response.status) {
                  dispatch(success(response.data));
                  customAlert(dispatch, 'success', i18n.t('warning_messages.admin_was_updated'));
               } else {
                  if(!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
               }
            },
            error => {
               customAlert(dispatch, 'error', i18n.t(defaultFailedText))
            }
         ).then(() => {
            loader(dispatch, false)
         })
   };
   function success(tmp) { return { type: masterAdminConstants.EDIT_ADMIN_SUCCESS, tmp } }
}

function deleteAdmin(params) {
   return dispatch => {
      loader(dispatch, true)
      dispatch({ type: masterAdminConstants.DELETE_ADMIN_REQUEST })
      masterAdminService.deleteAdmin(params)
         .then(
            tmp => {
               if (tmp.status) {
                  dispatch(success(tmp.data));
                  customAlert(dispatch, 'success', i18n.t("warning_messages.admin_was_deleted"))
               } else {
                  if(!tmp.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${tmp.message.toString()}`))
               }
            },
            error => {
               customAlert(dispatch, 'error', i18n.t(defaultFailedText))
            }
         ).then(() => {
            loader(dispatch, false)
         })
   };
   function success(tmp) { return { type: masterAdminConstants.DELETE_ADMIN_SUCCESS, tmp } }
}

function getTableDatas(params) {
   return dispatch => {
      dispatch({ type: masterAdminConstants.SHOW_TABLE_LOADER })
      masterAdminService.getListsAdmin(params)
         .then(
            response => {
               if (response.status) {
                  dispatch(success(response.data));
               } else {
                  if(!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
               }
            },
            error => {
               customAlert(dispatch, 'error', i18n.t(defaultFailedText))
            }
         ).then(() => {
            dispatch({ type: masterAdminConstants.HIDE_TABLE_LOADER })
         })
   };

   function success(tmp) { return { type: masterAdminConstants.TABLE_GET_LIST_DATAS, tmp } }
}

function getAdminByID(params) {
   return dispatch => {
       loader(dispatch, true)
       masterAdminService.getAdminByID(params)
           .then(
               response => {
                   if (response.status) {
                       dispatch(success(response.data));
                   } else {
                       if(!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
                   }
               },
               error => {
                   customAlert(dispatch, 'error', i18n.t(defaultFailedText))
               }
           ).then(() => {
               loader(dispatch, false)
           })
   };



   function success(data) { 
      return  { type: masterAdminConstants.OPEN_FORM_EDIT, formInitialValue: data }
   }
}

function getListMerchants() {
   return dispatch => {
      dispatch({ type: masterAdminConstants.SHOW_TABLE_LOADER })
      masterAdminService.getListMerchants()
         .then(
            response => {
               if (response.status) {
                  dispatch(success(response.data));
               } else {
                  if(!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
               }
            },
            error => {
               customAlert(dispatch, 'error', i18n.t(defaultFailedText))
            }
         ).then(() => {
            dispatch({ type: masterAdminConstants.HIDE_TABLE_LOADER })
         })
   };

   function success(tmp) { return { type: masterAdminConstants.TABLE_GET_LIST_MERCHANTS, tmp } }
}

function editPassword(params) {
   return dispatch => {
      loader(dispatch, true)
      masterAdminService.editPassword(params)
         .then(
            response => {
               if (response.status) {
                  dispatch(success(response.data));
                  customAlert(dispatch, 'success', i18n.t('warning_messages.admin_was_updated'));
               } else {
                  if(!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
               }
            },
            error => {
               customAlert(dispatch, 'error', i18n.t(defaultFailedText))
            }
         ).then(() => {
            loader(dispatch, false)
         })
   };
   function success(tmp) { return { type: masterAdminConstants.EDIT_PASSWORD_ADMIN_SUCCESS, tmp } }
}


function emailPasswordExpire(params) {
   return dispatch => {
      loader(dispatch, true)
      masterAdminService.emailPasswordExpire(params)
         .then(
            response => {
               if (response.status) {
                  dispatch(success(response.data));
                  customAlert(dispatch, 'success', 'ส่ง Email สำเร็จ');
               } else {
                  if(!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
               }
            },
            error => {
               customAlert(dispatch, 'error', i18n.t(defaultFailedText))
            }
         ).then(() => {
            loader(dispatch, false)
         })
   };
   function success(tmp) { return { type: masterAdminConstants.EMAIL_PASSWORD_EXPIRE_SUCCES, tmp } }
}